import React, { useState } from 'react'

import HelpButton from './HelpButton'
import { useVisibleTutorials } from './hooks'
import TutorialPlayerDialog from './TutorialPlayerDialog'
import TutorialsDrawer from './TutorialsDrawer'
import type { TrainingVideo } from '../../types/Training/TrainingVideo'

const PageHelp = () => {
	const [drawerOpen, setDrawerOpen] = useState(false)
	const [selectedTutorial, setSelectedTutorial] = useState<TrainingVideo | null>(null)
	const [playerOpen, setPlayerOpen] = useState(false)
	const { tutorials, isLoading, errorMessage, refetch } = useVisibleTutorials()

	const openDrawer = () => setDrawerOpen(true)
	const closeDrawer = () => setDrawerOpen(false)

	const openTutorial = (tutorial: TrainingVideo) => {
		setSelectedTutorial(tutorial)
		setPlayerOpen(true)
	}

	const closeTutorialPlayer = () => {
		setPlayerOpen(false)
		setSelectedTutorial(null)
	}

	return (
		<>
			<HelpButton onClick={openDrawer} />
			<TutorialsDrawer
				open={drawerOpen}
				onClose={closeDrawer}
				// pageLabel={pageLabel}
				tutorials={tutorials}
				isLoading={isLoading}
				errorMessage={errorMessage}
				onRetry={refetch}
				onSelectTutorial={openTutorial}
			/>
			<TutorialPlayerDialog open={playerOpen} tutorial={selectedTutorial} onClose={closeTutorialPlayer} />
		</>
	)
}

export default PageHelp
